import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    baseShrinkRatio: 0.5
};
/**
 * Represents a Manual Operation shape, a flowchart element used to indicate a manual process or operation.
 * Extends the Rectangle class with a custom trapezoid path.
 */
export class ManualOperation extends Rectangle {
    /**
     * Creates a new ManualOperation instance.
     * @param options - Configuration options for the manual operation shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the manual operation shape path as a trapezoid.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const baseShrink = width * this.options.baseShrinkRatio;
        const points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width - baseShrink / 2, y: height },
            { x: baseShrink / 2, y: height }
        ];
        drawRoundedPolygon(drawingElement, points, this.options.cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
